import $ from 'jquery';
import MicroModal from 'micromodal';
import embedYoutube from './../features/youtube-player';
import embedVimeo from './../features/vimeo-player';

export function popupVideo(container) {
  const $triggers = $(container).find('[data-video-popup]');
  const $backgroundVideo = $(container).find('[data-video-autoplay]');

  $.each($triggers, function(index, trigger) {
    // Extract the video information from the button trigger
    const $trigger = $(trigger);
    const unique = $trigger.attr('data-unique');
    const video = $trigger.attr('data-video-id');
    const type = $trigger.attr('data-video-type');

    // Find the modal body, which has been moved to the document root
    // and append a unique ID for youtube and vimeo to init players.
    const uniqueKey = `${video}-${unique}`;
    const $player = $(document).find(`[data-player="${uniqueKey}"]`);

    // Modal Event Logic:
    // When a modal opens it creates and plays the video
    // When a modal opens it pauses background videos in this section
    // --
    // When a modal closes it destroys the player
    // When a modal closes it plays background videos anywhere on the page

    MicroModal.init({
      onShow: () => {
        $backgroundVideo.trigger('pause');
        let playerPromise = {};
        if (type === 'youtube') {
          playerPromise = embedYoutube(uniqueKey);
        } else if (type === 'vimeo') {
          playerPromise = embedVimeo(uniqueKey);
        }
        playerPromise.then(() => {
          $player.trigger('play');
        });
      },
      onClose: () => {
        $player.trigger('destroy');
        $backgroundVideo.trigger('play');
      },
      openTrigger: `data-trigger-${video}-${unique}`,
    });
  });
}
